import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import Geosuggest from '@ubilabs/react-geosuggest';
import { useDispatch, useSelector } from 'react-redux';
import { getRequest } from '../../../requestUtils';
import MultiSelectInput from '../../common/MultiSelectInput';
import profileSuggestionsActions from '../../../actions/profileSuggestionsActions';
import { analyticsTrack } from '../../../analyticsUtils';
import allActions from '../../../actions';
var getCurrentQuestionsFromKeys = function getCurrentQuestionsFromKeys(questionKeys, questionableId, questionableType, questionnaireName) {
  return getRequest('/question_answers/questions', {
    questionnaire_question_keys: questionKeys,
    questionable_id: questionableId,
    questionable_type: questionableType,
    questionnaire_name: questionnaireName
  });
};
function SelectableItem(_ref) {
  var onEdit = _ref.onEdit,
    onToggle = _ref.onToggle,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? true : _ref$checked,
    _ref$itemEditable = _ref.itemEditable,
    itemEditable = _ref$itemEditable === void 0 ? true : _ref$itemEditable,
    child = _ref.child,
    error = _ref.error;
  return /*#__PURE__*/React.createElement("div", {
    className: "selectable-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selectable"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    className: "checkbox",
    type: "checkbox",
    id: "boolean",
    checked: checked,
    onChange: function onChange() {
      return onToggle(!checked);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "child ".concat(checked ? '' : 'unchecked')
  }, child), itemEditable && /*#__PURE__*/React.createElement("div", {
    className: "edit",
    style: {
      pointerEvents: checked ? 'all' : 'none'
    },
    onClick: function onClick() {
      return onEdit();
    },
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-pencil-alt"
  }))), error && /*#__PURE__*/React.createElement("div", {
    className: "error"
  }, error, ' '));
}
SelectableItem.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  itemEditable: PropTypes.bool,
  child: PropTypes.node,
  error: PropTypes.string
};
SelectableItem.defaultProps = {
  checked: true,
  itemEditable: true,
  child: null,
  error: null
};
function Summary(_ref2) {
  var userId = _ref2.userId,
    hasChanged = _ref2.hasChanged,
    accepted = _ref2.accepted,
    bio = _ref2.bio,
    onUpdate = _ref2.onUpdate,
    onToggle = _ref2.onToggle;
  var _useState = useState(bio),
    _useState2 = _slicedToArray(_useState, 2),
    modalSummaryValue = _useState2[0],
    setModalSummaryValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isEditModalVisible = _useState4[0],
    setEditModalVisibility = _useState4[1];
  useEffect(function () {
    setModalSummaryValue(bio);
  }, [bio]);
  var update = function update() {
    setEditModalVisibility(false);
    onUpdate(modalSummaryValue);
  };
  var edit = function edit() {
    setEditModalVisibility(true);
    analyticsTrack('Editing bio', {
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "bio"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, "Bio")), /*#__PURE__*/React.createElement(SelectableItem, {
    onToggle: onToggle,
    onEdit: function onEdit() {
      return edit();
    },
    checked: accepted,
    child: /*#__PURE__*/React.createElement("div", null, bio)
  }), hasChanged && /*#__PURE__*/React.createElement("div", {
    className: "has-changed"
  }, "Adding this BIO will override your current bio"), /*#__PURE__*/React.createElement(Modal, {
    show: isEditModalVisible,
    onHide: function onHide() {
      return setEditModalVisibility(false);
    }
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "edit-suggestion"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React.createElement("header", {
    className: "header"
  }, "Edit Summary"), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, "What is your new bio?"), /*#__PURE__*/React.createElement("div", {
    className: "input-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-label"
  }, "Summary"), /*#__PURE__*/React.createElement("textarea", {
    className: "input-base",
    rows: "4",
    placeholder: "Write here...",
    value: modalSummaryValue,
    required: false,
    onChange: function onChange(v) {
      return setModalSummaryValue(v.target.value);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "buttons-bar"
  }, /*#__PURE__*/React.createElement("button", {
    className: "save",
    onClick: function onClick() {
      return update();
    }
  }, "Save Changes"), /*#__PURE__*/React.createElement("button", {
    className: "cancel",
    onClick: function onClick() {
      return setEditModalVisibility(false);
    }
  }, "Cancel")))));
}
Summary.propTypes = {
  userId: PropTypes.string.isRequired,
  hasChanged: PropTypes.bool.isRequired,
  accepted: PropTypes.bool.isRequired,
  bio: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired
};
function Location(_ref3) {
  var userId = _ref3.userId,
    hasChanged = _ref3.hasChanged,
    accepted = _ref3.accepted,
    location = _ref3.location,
    onUpdate = _ref3.onUpdate,
    onToggle = _ref3.onToggle;
  var _useState5 = useState(location),
    _useState6 = _slicedToArray(_useState5, 2),
    modalLocationValue = _useState6[0],
    setModalLocationValue = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isEditModalVisible = _useState8[0],
    setEditModalVisibility = _useState8[1];
  useEffect(function () {
    setModalLocationValue(location);
  }, [location]);
  var update = function update() {
    setEditModalVisibility(false);
    onUpdate(modalLocationValue);
  };
  var edit = function edit() {
    setEditModalVisibility(true);
    analyticsTrack('Editing location', {
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
  };
  var clear = function clear() {
    setModalLocationValue('');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "location"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, "Location")), /*#__PURE__*/React.createElement(SelectableItem, {
    onToggle: onToggle,
    onEdit: function onEdit() {
      return edit();
    },
    checked: accepted,
    child: /*#__PURE__*/React.createElement("div", null, location)
  }), hasChanged && /*#__PURE__*/React.createElement("div", {
    className: "has-changed"
  }, "Adding this Location will override your current location"), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(Modal, {
    show: isEditModalVisible,
    onHide: function onHide() {
      return setEditModalVisibility(false);
    }
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "edit-suggestion"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body"
  }, /*#__PURE__*/React.createElement("header", {
    className: "header"
  }, "Edit Location"), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, "What is your new location?"), /*#__PURE__*/React.createElement("div", {
    className: "input-field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-label"
  }, "City or postal code"), /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement(Geosuggest, {
    initialValue: modalLocationValue,
    suggestItemClassName: "geosuggest-font",
    inputClassName: "input-base",
    placeholder: "Type your current location",
    onSuggestSelect: function onSuggestSelect(obj) {
      return obj && setModalLocationValue(obj.label);
    }
  }), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return clear();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-times"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "buttons-bar"
  }, /*#__PURE__*/React.createElement("button", {
    className: "save",
    onClick: function onClick() {
      return update();
    }
  }, "Save Changes"), /*#__PURE__*/React.createElement("button", {
    className: "cancel",
    onClick: function onClick() {
      return setEditModalVisibility(false);
    }
  }, "Cancel")))));
}
Location.propTypes = {
  userId: PropTypes.string.isRequired,
  hasChanged: PropTypes.bool.isRequired,
  accepted: PropTypes.bool.isRequired,
  location: PropTypes.string.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired
};
var isDate = function isDate(date) {
  if (!date) {
    return false;
  }
  var convertedDate = new Date(date);
  return convertedDate !== 'Invalid Date' && !isNaN(convertedDate);
};
var yearOptions = function yearOptions() {
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("option", {
    key: "select",
    value: ""
  }, "Select year"), Array(new Date().getFullYear() - 1969).fill().map(function (_, idx) {
    return 1970 + idx;
  }).map(function (i) {
    return /*#__PURE__*/React.createElement("option", {
      key: i,
      value: i
    }, i);
  }));
};
function EducationItem(_ref4) {
  var education = _ref4.education;
  var startDate = '';
  if (Object.prototype.hasOwnProperty.call(education, 'startDate') && isDate(education.startDate)) {
    startDate = new Date(education.startDate).getFullYear();
  }
  var endDate = '';
  if (Object.prototype.hasOwnProperty.call(education, 'endDate') && isDate(education.endDate)) {
    endDate = new Date(education.endDate).getFullYear();
  }
  var degreeLabel = '';
  if (Object.prototype.hasOwnProperty.call(education, 'degree') && _typeof(education.degree) === 'object' && education.degree != null && Object.prototype.hasOwnProperty.call(education.degree, 'label')) {
    degreeLabel = education.degree.label;
  } else {
    degreeLabel = education.degree;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text text-1"
  }, degreeLabel), /*#__PURE__*/React.createElement("div", {
    className: "text text-2"
  }, education.school), /*#__PURE__*/React.createElement("div", {
    className: "text text-3"
  }, startDate, ' ', "-", ' ', endDate));
}
EducationItem.propTypes = {
  education: PropTypes.shape({}).isRequired
};
function Education(_ref5) {
  var userId = _ref5.userId,
    hasChanged = _ref5.hasChanged,
    education = _ref5.education,
    onUpdate = _ref5.onUpdate,
    _onToggle = _ref5.onToggle,
    question = _ref5.question,
    errors = _ref5.errors;
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isEditModalVisible = _useState10[0],
    setEditModalVisibility = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    editingItem = _useState12[0],
    setEditingItem = _useState12[1];
  var _useState13 = useState(-1),
    _useState14 = _slicedToArray(_useState13, 2),
    editingIndex = _useState14[0],
    setEditingIndex = _useState14[1];
  var updateItem = function updateItem() {
    onUpdate(editingIndex, editingItem);
    setEditModalVisibility(false);
    setEditingIndex(-1);
    setEditingItem(null);
  };
  var clearItem = function clearItem() {
    setEditingItem({
      degree: '',
      areaOfStudy: '',
      school: '',
      startDate: '',
      endDate: ''
    });
    _onToggle(editingIndex, false);
  };
  var onEditItem = function onEditItem(index) {
    setEditingItem(education[index].education);
    setEditingIndex(index);
    setEditModalVisibility(true);
    analyticsTrack('Editing education', {
      index: index,
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
  };
  var renderEditModal = function renderEditModal() {
    if (editingItem === null) {
      return null;
    }
    var className = [question.children_questions[0].question_type, question.children_questions[0].style, question.children_questions[0].question_key].join(' ');
    return /*#__PURE__*/React.createElement(Modal, {
      show: isEditModalVisible,
      onHide: function onHide() {
        return setEditModalVisibility(false);
      }
    }, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }), /*#__PURE__*/React.createElement(Modal.Body, {
      className: "edit-suggestion"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body"
    }, /*#__PURE__*/React.createElement("header", {
      className: "header"
    }, "Edit Education"), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Degree"), /*#__PURE__*/React.createElement(Select, {
      components: {
        IndicatorSeparator: function IndicatorSeparator() {
          return null;
        },
        DropdownIndicator: function DropdownIndicator() {
          return /*#__PURE__*/React.createElement("i", {
            className: "fas fa-angle-down"
          });
        }
      },
      className: className,
      classNamePrefix: "react-select",
      placeholder: "Select or type...",
      options: question.children_questions[0].options,
      value: editingItem.degree,
      onChange: function onChange(option) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          degree: option
        }));
      },
      isDisabled: false,
      menuPortalTarget: document.body,
      styles: {
        menuPortal: function menuPortal(base) {
          return _objectSpread(_objectSpread({}, base), {}, {
            zIndex: 9999
          });
        }
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Area of Study"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "input-base",
      placeholder: "Write here...",
      value: editingItem.areaOfStudy,
      required: false,
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          areaOfStudy: v.target.value
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "School"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "input-base",
      placeholder: "Write here...",
      value: editingItem.school,
      required: false,
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          school: v.target.value
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "one-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Year started"), /*#__PURE__*/React.createElement("select", {
      className: "input-base",
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          startDate: "".concat(v.target.value, "-01-01")
        }));
      },
      value: isDate(editingItem.startDate) ? moment(editingItem.startDate).toDate().getFullYear() : ''
    }, yearOptions())), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Year done"), /*#__PURE__*/React.createElement("select", {
      className: "input-base",
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          endDate: "".concat(v.target.value, "-01-01")
        }));
      },
      value: isDate(editingItem.endDate) ? moment(editingItem.endDate).toDate().getFullYear() : ''
    }, yearOptions())))), /*#__PURE__*/React.createElement("div", {
      className: "buttons-bar"
    }, /*#__PURE__*/React.createElement("button", {
      className: "save",
      onClick: function onClick() {
        return updateItem();
      }
    }, "Save Changes"), /*#__PURE__*/React.createElement("button", {
      className: "clear",
      onClick: function onClick() {
        return clearItem();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-trash-alt"
    }), "Remove"), /*#__PURE__*/React.createElement("button", {
      className: "cancel",
      onClick: function onClick() {
        return setEditModalVisibility(false);
      }
    }, "Cancel"))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "education"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, "Education")), /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, education.map(function (e, index) {
    return /*#__PURE__*/React.createElement(SelectableItem, {
      key: "education-".concat(index),
      onToggle: function onToggle() {
        return _onToggle(index, !e.accepted);
      },
      onEdit: function onEdit() {
        return onEditItem(index);
      },
      error: errors[index],
      checked: e.accepted,
      child: /*#__PURE__*/React.createElement(EducationItem, {
        education: e.education
      })
    });
  })), hasChanged && /*#__PURE__*/React.createElement("div", {
    className: "has-changed"
  }, "Adding these Education will override your current Education"), renderEditModal());
}
Education.propTypes = {
  userId: PropTypes.string.isRequired,
  hasChanged: PropTypes.bool.isRequired,
  education: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  question: PropTypes.shape({}).isRequired,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired
};
function PastRoleItem(_ref6) {
  var pastRole = _ref6.pastRole;
  var startDate = '';
  if (isDate(pastRole.startDate)) {
    startDate = new Date(pastRole.startDate).getFullYear();
  }
  var endDate = '';
  if (isDate(pastRole.endDate)) {
    endDate = new Date(pastRole.endDate).getFullYear();
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text text-1"
  }, pastRole.title), /*#__PURE__*/React.createElement("div", {
    className: "text text-2"
  }, pastRole.companyName), /*#__PURE__*/React.createElement("div", {
    className: "text text-3"
  }, startDate, ' ', "-", ' ', endDate), /*#__PURE__*/React.createElement("div", {
    className: "text text-4"
  }, pastRole.description));
}
PastRoleItem.propTypes = {
  pastRole: PropTypes.shape({}).isRequired
};
function PastRoles(_ref7) {
  var userId = _ref7.userId,
    hasChanged = _ref7.hasChanged,
    pastRoles = _ref7.pastRoles,
    onUpdate = _ref7.onUpdate,
    _onToggle2 = _ref7.onToggle;
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isEditModalVisible = _useState16[0],
    setEditModalVisibility = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    editingItem = _useState18[0],
    setEditingItem = _useState18[1];
  var _useState19 = useState(-1),
    _useState20 = _slicedToArray(_useState19, 2),
    editingIndex = _useState20[0],
    setEditingIndex = _useState20[1];
  var updateItem = function updateItem() {
    onUpdate(editingIndex, editingItem);
    setEditModalVisibility(false);
    setEditingIndex(-1);
    setEditingItem(null);
  };
  var clearItem = function clearItem() {
    setEditingItem({
      title: '',
      companyName: '',
      startDate: '',
      endDate: '',
      description: ''
    });
    _onToggle2(editingIndex, false);
  };
  var onEditItem = function onEditItem(index) {
    setEditingItem(pastRoles[index].pastRole);
    setEditingIndex(index);
    setEditModalVisibility(true);
    analyticsTrack('Editing Past roles', {
      index: index,
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
  };
  var renderEditModal = function renderEditModal() {
    if (editingItem === null) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Modal, {
      show: isEditModalVisible,
      onHide: function onHide() {
        return setEditModalVisibility(false);
      }
    }, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }), /*#__PURE__*/React.createElement(Modal.Body, {
      className: "edit-suggestion"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body"
    }, /*#__PURE__*/React.createElement("header", {
      className: "header"
    }, "Edit Past Role"), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Title"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "input-base",
      placeholder: "Write here...",
      value: editingItem.title,
      required: false,
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          title: v.target.value
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Company name"), /*#__PURE__*/React.createElement("input", {
      type: "text",
      className: "input-base",
      placeholder: "Write here...",
      value: editingItem.companyName,
      required: false,
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          companyName: v.target.value
        }));
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: "one-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Year started"), /*#__PURE__*/React.createElement("select", {
      className: "input-base",
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          startDate: "".concat(v.target.value, "-01-01")
        }));
      },
      value: isDate(editingItem.startDate) ? moment(editingItem.startDate).toDate().getFullYear() : ''
    }, yearOptions())), /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Year done"), /*#__PURE__*/React.createElement("select", {
      className: "input-base",
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          endDate: "".concat(v.target.value, "-01-01")
        }));
      },
      value: isDate(editingItem.endDate) ? moment(editingItem.endDate).toDate().getFullYear() : ''
    }, yearOptions()))), /*#__PURE__*/React.createElement("div", {
      className: "one-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-field"
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-label"
    }, "Description"), /*#__PURE__*/React.createElement("textarea", {
      rows: "5",
      type: "text",
      className: "input-base",
      placeholder: "Write here...",
      value: editingItem.description,
      required: false,
      onChange: function onChange(v) {
        return setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
          description: v.target.value
        }));
      }
    })))), /*#__PURE__*/React.createElement("div", {
      className: "buttons-bar"
    }, /*#__PURE__*/React.createElement("button", {
      className: "save",
      onClick: function onClick() {
        return updateItem();
      }
    }, "Save Changes"), /*#__PURE__*/React.createElement("button", {
      className: "clear",
      onClick: function onClick() {
        return clearItem();
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-trash-alt"
    }), "Remove"), /*#__PURE__*/React.createElement("button", {
      className: "cancel",
      onClick: function onClick() {
        return setEditModalVisibility(false);
      }
    }, "Cancel"))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "past-roles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, "Past Roles")), /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, pastRoles.map(function (e, index) {
    return e.pastRole && (e.pastRole.companyName || e.pastRole.title || e.pastRole.description) && /*#__PURE__*/React.createElement(SelectableItem, {
      key: "pastRole-".concat(index),
      onToggle: function onToggle() {
        return _onToggle2(index, !e.accepted);
      },
      onEdit: function onEdit() {
        return onEditItem(index);
      },
      checked: e.accepted,
      child: /*#__PURE__*/React.createElement(PastRoleItem, {
        pastRole: e.pastRole
      })
    });
  })), hasChanged && /*#__PURE__*/React.createElement("div", {
    className: "has-changed"
  }, "Adding these Past roles will override your current Past Roles"), renderEditModal());
}
PastRoles.propTypes = {
  userId: PropTypes.string.isRequired,
  hasChanged: PropTypes.bool.isRequired,
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onUpdate: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired
};
var TAGs = [{
  id: 'functionalAreas',
  name: 'Functional Areas',
  key: 'functional_areas'
}, {
  id: 'therapeuticAreas',
  name: 'Therapeutic Areas',
  key: 'therapeutic_areas'
}, {
  id: 'industries',
  name: 'Industries',
  key: 'industries'
}, {
  id: 'stagesOfDevelopments',
  name: 'Stages Of Development',
  key: 'stages_of_development'
}, {
  id: 'productTechnologies',
  name: 'Product Technologies',
  key: 'product_technologies'
}];
function TagItem(_ref8) {
  var tag = _ref8.tag;
  return /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text text-1"
  }, tag.label));
}
TagItem.propTypes = {
  tag: PropTypes.shape({}).isRequired
};
function Tags(_ref9) {
  var userId = _ref9.userId,
    id = _ref9.id,
    name = _ref9.name,
    hasChanged = _ref9.hasChanged,
    question = _ref9.question,
    tags = _ref9.tags,
    onUpdate = _ref9.onUpdate;
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    isEditModalVisible = _useState22[0],
    setEditModalVisibility = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    editingItem = _useState24[0],
    setEditingItem = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    values = _useState26[0],
    setValues = _useState26[1];
  useEffect(function () {
    var initialTags = tags.filter(function (t) {
      return t.accepted;
    }).map(function (t) {
      return t[id.slice(0, id.length - 1)];
    }).flat();
    setValues(initialTags);
  }, [tags, question]);
  var updateItem = function updateItem() {
    onUpdate(id, values.map(function (v) {
      return _defineProperty({
        accepted: true
      }, id.slice(0, id.length - 1), {
        name: v.label,
        user_created: false
      });
    }));
    setEditModalVisibility(false);
  };
  var onToggleItem = function onToggleItem(index, accepted) {
    var newTags = tags.map(function (e, ix) {
      if (ix === index) {
        return _objectSpread(_objectSpread({}, e), {}, {
          accepted: accepted
        });
      }
      return e;
    });
    var field = id.slice(0, id.length - 1);
    var label;
    try {
      label = tags[index].label;
    } catch (error) {
      label = "Tag:".concat(id, ":Label:").concat(index);
    }
    analyticsTrack("Accepting/Declining ".concat(name.slice(0, name.length - 1)), {
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions',
      action: accepted ? 'Accepting' : 'Declining',
      item: label,
      userId: userId
    });
    onUpdate(id, newTags.map(function (t) {
      return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, field, {
        name: t[field].label,
        user_created: false
      }));
    }));
  };
  var clearItem = function clearItem() {
    setEditingItem(_objectSpread(_objectSpread({}, editingItem), {}, {
      name: ''
    }));
  };
  var onEdit = function onEdit() {
    analyticsTrack("Editing ".concat(name.slice(0, name.length - 1)), {
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
    setEditModalVisibility(true);
  };
  var renderEditModal = function renderEditModal() {
    if (!question) {
      return null;
    }
    var subtext = question.subtext,
      options = question.answer_options,
      asyncUrl = question.async_url,
      disabled = question.disabled,
      hasOther = question.has_other,
      hasFilter = question.has_filter,
      questionType = question.question_type,
      style = question.style,
      limit = question.limit,
      key = question.key;
    return /*#__PURE__*/React.createElement(Modal, {
      dialogClassName: "tags-modal",
      show: isEditModalVisible,
      onHide: function onHide() {
        return setEditModalVisibility(false);
      }
    }, /*#__PURE__*/React.createElement(Modal.Header, {
      closeButton: true
    }), /*#__PURE__*/React.createElement(Modal.Body, {
      className: "edit-suggestion"
    }, /*#__PURE__*/React.createElement("div", {
      className: "body question new-design"
    }, /*#__PURE__*/React.createElement("header", {
      className: "header"
    }, "Edit", name), /*#__PURE__*/React.createElement(MultiSelectInput, {
      subtext: subtext,
      options: options,
      values: values,
      handleSelectChange: function handleSelectChange(option) {
        return setValues(option);
      },
      asyncUrl: asyncUrl,
      disabled: disabled,
      hasOther: hasOther,
      hasFilter: hasFilter,
      style: style,
      limit: limit,
      onlyCustom: questionType === 'only_custom_tags',
      onboardingQuestionnaire: false,
      questionKey: key,
      text: name
    })), /*#__PURE__*/React.createElement("div", {
      className: "buttons-bar"
    }, /*#__PURE__*/React.createElement("button", {
      className: "save",
      onClick: function onClick() {
        return updateItem();
      }
    }, "Save Changes"), /*#__PURE__*/React.createElement("button", {
      className: "clear",
      onClick: function onClick() {
        return clearItem();
      }
    }, "Clear"), /*#__PURE__*/React.createElement("button", {
      className: "cancel",
      onClick: function onClick() {
        return setEditModalVisibility(false);
      }
    }, "Cancel"))));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, name), /*#__PURE__*/React.createElement("div", {
    className: "edit",
    onClick: function onClick() {
      return onEdit();
    },
    role: "button",
    tabIndex: "0"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-pencil-alt"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "block"
  }, tags.filter(function (item) {
    return item[id.slice(0, id.length - 1)];
  }).map(function (item, index) {
    return /*#__PURE__*/React.createElement(SelectableItem, {
      key: "".concat(id, "-").concat(index),
      checked: item.accepted,
      itemEditable: false,
      onToggle: function onToggle() {
        return onToggleItem(index, !item.accepted);
      },
      child: /*#__PURE__*/React.createElement(TagItem, {
        tag: item[id.slice(0, id.length - 1)]
      })
    });
  })), hasChanged && /*#__PURE__*/React.createElement("div", {
    className: "has-changed"
  }, "Adding these", name, ' ', "will override your current", name), renderEditModal());
}
Tags.propTypes = {
  userId: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  hasChanged: PropTypes.bool.isRequired,
  question: PropTypes.shape({}).isRequired,
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onUpdate: PropTypes.func.isRequired
};
function ProfileSuggestions(_ref11) {
  var userId = _ref11.userId,
    questionnaireName = _ref11.questionnaireName,
    questionableId = _ref11.questionableId,
    questionableType = _ref11.questionableType,
    fromOnboarding = _ref11.fromOnboarding;
  var _useSelector = useSelector(function (state) {
      return state.profileSuggestions;
    }),
    profileSuggestions = _useSelector.profileSuggestions,
    hasChanged = _useSelector.hasChanged,
    errorsProfileSuggestions = _useSelector.errors;
  var dispatch = useDispatch();
  var resumeOnly = fromOnboarding ? '' : 'resume_only=true';
  var getProfileSuggestions = function getProfileSuggestions() {
    return getRequest("/users/".concat(userId, "/profile_suggestions?").concat(resumeOnly));
  };
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    currentSuggestion = _useState28[0],
    setCurrentSuggestion = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    tagsQuestions = _useState30[0],
    setTagsQuestions = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    educationQuestion = _useState32[0],
    setEducationQuestion = _useState32[1];
  useEffect(function () {
    var getData = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, _response$data, suggestions, answers, changed;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getProfileSuggestions(userId);
            case 2:
              response = _context.sent;
              _response$data = response.data, suggestions = _response$data.suggestions, answers = _response$data.answers, changed = _response$data.changed;
              dispatch(allActions.profileSuggestions.profileSuggestionsParsed({
                suggestions: suggestions,
                changed: changed,
                answers: answers
              }));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getData() {
        return _ref12.apply(this, arguments);
      };
    }();
    if (!fromOnboarding) {
      getData();
    }
  }, []);
  useEffect(function () {
    var _profileSuggestions$m = profileSuggestions.merged,
      functionalAreas = _profileSuggestions$m.functionalAreas,
      therapeuticAreas = _profileSuggestions$m.therapeuticAreas,
      industries = _profileSuggestions$m.industries,
      productTechnologies = _profileSuggestions$m.productTechnologies,
      stagesOfDevelopments = _profileSuggestions$m.stagesOfDevelopments;
    if (profileSuggestions.updated) {
      analyticsTrack('Is getting suggestions', {
        location: fromOnboarding ? 'Onboarding Flow' : 'Consultant Onboarding',
        sublocation: 'Profile Suggestions',
        userId: userId
      });
    }
    if (tagsQuestions.length > 0) {
      // Functional Areas
      var question = tagsQuestions.find(function (q) {
        return q.question_key === 'functional_areas';
      });
      functionalAreas = functionalAreas.map(function (fa) {
        return _objectSpread(_objectSpread({}, fa), {}, {
          functionalArea: question.answer_options.find(function (opt) {
            return opt.label === fa.functionalArea.name;
          })
        });
      });
      // Therapeutic Areas
      question = tagsQuestions.find(function (q) {
        return q.question_key === 'therapeutic_areas';
      });
      therapeuticAreas = therapeuticAreas.map(function (ta) {
        return _objectSpread(_objectSpread({}, ta), {}, {
          therapeuticArea: question.answer_options.find(function (opt) {
            return opt.label === ta.therapeuticArea.name;
          })
        });
      });
      // Industries
      question = tagsQuestions.find(function (q) {
        return q.question_key === 'industries';
      });
      industries = industries.map(function (i) {
        return _objectSpread(_objectSpread({}, i), {}, {
          industrie: question.answer_options.find(function (opt) {
            return opt.label === i.industrie.name;
          })
        });
      });
      // Product Technologies
      question = tagsQuestions.find(function (q) {
        return q.question_key === 'product_technologies';
      });
      productTechnologies = productTechnologies.map(function (pt) {
        return _objectSpread(_objectSpread({}, pt), {}, {
          productTechnologie: question.answer_options.find(function (opt) {
            return opt.label === pt.productTechnologie.name;
          })
        });
      });
      // Stages Of Development
      question = tagsQuestions.find(function (q) {
        return q.question_key === 'stages_of_development';
      });
      stagesOfDevelopments = stagesOfDevelopments.map(function (sod) {
        return _objectSpread(_objectSpread({}, sod), {}, {
          stagesOfDevelopment: question.answer_options.find(function (opt) {
            return opt.label === sod.stagesOfDevelopment.name;
          })
        });
      });
    }
    setCurrentSuggestion(_objectSpread(_objectSpread({}, profileSuggestions.merged), {}, {
      functionalAreas: functionalAreas,
      therapeuticAreas: therapeuticAreas,
      industries: industries,
      productTechnologies: productTechnologies,
      stagesOfDevelopments: stagesOfDevelopments
    }));
  }, [profileSuggestions, tagsQuestions]);
  useEffect(function () {
    var getQuestionDetails = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getCurrentQuestionsFromKeys(['functional_areas', 'therapeutic_areas', 'industries', 'stages_of_development', 'product_technologies', 'education'], questionableId, questionableType, questionnaireName);
            case 2:
              response = _context2.sent;
              setEducationQuestion(response.data.find(function (q) {
                return q.question_key === 'education';
              }));
              setTagsQuestions(response.data.filter(function (q) {
                return q.question_key !== 'education';
              }));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getQuestionDetails() {
        return _ref13.apply(this, arguments);
      };
    }();
    getQuestionDetails();
  }, [questionnaireName, questionableId, questionableType]);
  var onToggleSummary = function onToggleSummary(accepted) {
    var bio = currentSuggestion.bio;
    var updatedBio = _objectSpread(_objectSpread({}, bio), {}, {
      accepted: accepted
    });
    analyticsTrack('Accepting/Declining bio', {
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions',
      userId: userId,
      action: accepted ? 'Accepting' : 'Declining'
    });
    dispatch(profileSuggestionsActions.updateBio(updatedBio));
  };
  var onUpdateSummary = function onUpdateSummary(newSummary) {
    var bio = currentSuggestion.bio;
    var updatedBio = _objectSpread(_objectSpread({}, bio), {}, {
      bio: newSummary
    });
    analyticsTrack('Updating bio', {
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
    dispatch(profileSuggestionsActions.updateBio(updatedBio));
  };
  var onToggleLocation = function onToggleLocation(accepted) {
    var location = currentSuggestion.location;
    analyticsTrack('Accepting/Declining location', {
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions',
      userId: userId,
      action: accepted ? 'Accepting' : 'Declining'
    });
    var updatedLocation = _objectSpread(_objectSpread({}, location), {}, {
      accepted: accepted
    });
    dispatch(profileSuggestionsActions.updateLocation(updatedLocation));
  };
  var onUpdateLocation = function onUpdateLocation(newLocation) {
    var location = currentSuggestion.location;
    analyticsTrack('Updating location', {
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
    var updatedLocation = _objectSpread(_objectSpread({}, location), {}, {
      location: newLocation
    });
    dispatch(profileSuggestionsActions.updateLocation(updatedLocation));
  };
  var onToggleEducation = function onToggleEducation(index, accepted) {
    var education = currentSuggestion.education;
    var newEducations = education.map(function (e, ix) {
      if (ix === index) {
        return _objectSpread(_objectSpread({}, e), {}, {
          accepted: accepted
        });
      }
      return e;
    });
    analyticsTrack('Accepting/Declining education', {
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions',
      index: index,
      userId: userId,
      action: accepted ? 'Accepting' : 'Declining'
    });
    dispatch(profileSuggestionsActions.updateArray('education', newEducations));
  };
  var onUpdateEducation = function onUpdateEducation(index, newEducation) {
    var education = currentSuggestion.education;
    var newEducations = education.map(function (e, ix) {
      if (ix === index) {
        return _objectSpread(_objectSpread({}, e), {}, {
          education: newEducation
        });
      }
      return e;
    });
    analyticsTrack('Updating education', {
      index: index,
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
    dispatch(profileSuggestionsActions.updateArray('education', newEducations));
  };
  var onTogglePastRole = function onTogglePastRole(index, accepted) {
    var pastRoles = currentSuggestion.pastRoles;
    var newPastRoles = pastRoles.map(function (e, ix) {
      if (ix === index) {
        return _objectSpread(_objectSpread({}, e), {}, {
          accepted: accepted
        });
      }
      return e;
    });
    analyticsTrack('Accepting/Declining Past roles', {
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions',
      index: index,
      userId: userId,
      action: accepted ? 'Accepting' : 'Declining'
    });
    dispatch(profileSuggestionsActions.updateArray('pastRoles', newPastRoles));
  };
  var onUpdatePastRole = function onUpdatePastRole(index, newPastRole) {
    var pastRoles = currentSuggestion.pastRoles;
    var newPastRoles = pastRoles.map(function (e, ix) {
      if (ix === index) {
        return _objectSpread(_objectSpread({}, e), {}, {
          pastRole: newPastRole
        });
      }
      return e;
    });
    dispatch(profileSuggestionsActions.updateArray('pastRoles', newPastRoles));
  };
  var onUpdateTag = function onUpdateTag(id, newTagsModified) {
    var name;
    try {
      name = TAGs.find(function (t) {
        return t.id === id;
      }).name.slice(0, name.length - 1);
    } catch (error) {
      name = "TAG:".concat(id);
    }
    analyticsTrack("Updating ".concat(name), {
      userId: userId,
      location: 'Onboarding Flow',
      sublocation: 'Profile Suggestions'
    });
    dispatch(profileSuggestionsActions.updateArray(id, newTagsModified));
  };
  if (!currentSuggestion || !profileSuggestions.updated) {
    return null;
  }
  if (!(currentSuggestion.bio.bio || currentSuggestion.location.location || currentSuggestion.education.length || currentSuggestion.pastRoles.length || TAGs.reduce(function (total, tag) {
    return total + (currentSuggestion[tag.id] || []).length;
  }, 0) > 0)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: "suggestion-card ".concat(fromOnboarding ? '' : 'consultant-profile')
  }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, "We found some profile suggestions for you!"), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, "Checked items will be added to your profile. You can pick and edit the items you would like to include in your Clora profile")), currentSuggestion.bio.bio && /*#__PURE__*/React.createElement(Summary, _extends({
    userId: userId,
    hasChanged: !fromOnboarding && hasChanged.bio
  }, currentSuggestion.bio, {
    onUpdate: function onUpdate(v) {
      return onUpdateSummary(v);
    },
    onToggle: function onToggle(v) {
      return onToggleSummary(v);
    }
  })), currentSuggestion.location.location && /*#__PURE__*/React.createElement(Location, _extends({
    userId: userId,
    hasChanged: !fromOnboarding && hasChanged.location
  }, currentSuggestion.location, {
    onUpdate: function onUpdate(v) {
      return onUpdateLocation(v);
    },
    onToggle: function onToggle(v) {
      return onToggleLocation(v);
    }
  })), currentSuggestion.education.length !== 0 && /*#__PURE__*/React.createElement(Education, {
    userId: userId,
    hasChanged: !fromOnboarding && hasChanged.education,
    education: currentSuggestion.education,
    onUpdate: onUpdateEducation,
    onToggle: onToggleEducation,
    question: educationQuestion,
    errors: errorsProfileSuggestions.education
  }), currentSuggestion.pastRoles.length !== 0 && /*#__PURE__*/React.createElement(PastRoles, {
    userId: userId,
    hasChanged: !fromOnboarding && hasChanged.pastRoles,
    pastRoles: currentSuggestion.pastRoles,
    onUpdate: onUpdatePastRole,
    onToggle: onTogglePastRole
  }), TAGs.map(function (tag) {
    return currentSuggestion[tag.id].length !== 0 && /*#__PURE__*/React.createElement(Tags, {
      userId: userId,
      id: tag.id,
      hasChanged: !fromOnboarding && hasChanged[tag.id],
      name: tag.name || "TAG:".concat(tag.id, ":s"),
      tags: currentSuggestion[tag.id],
      onUpdate: onUpdateTag,
      question: tagsQuestions.find(function (q) {
        return q.question_key === tag.key;
      })
    });
  }));
}
ProfileSuggestions.propTypes = {
  userId: PropTypes.string.isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  questionnaireName: PropTypes.string.isRequired,
  fromOnboarding: PropTypes.bool
};
ProfileSuggestions.defaultProps = {
  fromOnboarding: true
};
export default ProfileSuggestions;